import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  public showMenu: any = true;
  public studentData: any;

 public baseUrl: string = "https://api.rvirjitechnologies.com/api/";
   //public baseUrl = 'http://localhost:2222/api/';

  //!   //////////////////////////////////////////////////////////////////////////////////////////////////////////

  //get students for login 
constructor(
    public http: HttpClient,
  ) {
  }
  getStudent(data) {
    return this.http.post(this.baseUrl + "students/login", data);
  }

  //! jsPDF addImage needs base64 data, not a URL — fetch and convert before embedding
  async toDataUrl(url: any): Promise<any> {
    if (!url || typeof url !== 'string' || url.startsWith('data:')) return url;
    try {
      const blob = await fetch(url).then(r => r.blob());
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (err) {
      console.log(err, 'toDataUrl failed');
      return url;
    }
  }

  getMaterials(data) {
    return this.http.post(this.baseUrl + "materials/get_materials", data);
  }
  getQuestion(language) {
    return this.http.post(this.baseUrl + "questions/get_question", language);
  }
  saveExamAnswers(data) {
    return this.http.post(this.baseUrl + "answers/add_answers", data);
  }
  saveExamWithStatusUpdate(data) {
    return this.http.post(this.baseUrl + "students/update", data);
  }
  getOneStudentWithExamDetail(data) {
    //console.log(data,'data is hehe');
    return this.http.post(this.baseUrl + "students/getStudent_byFranchises_withExamDetail", data);

  }
}

